import React, { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { useField } from 'formik';

import Autocomplete, {
  AutocompleteOption,
  AutocompleteProps,
} from 'components/Autocomplete';

import { CitySelect_data$key } from '__generated__/CitySelect_data.graphql';

type Props = Omit<AutocompleteProps, 'options'> & {
  data: CitySelect_data$key;
  regionId?: string;
  hideCountryName?: boolean;
};

const groupBy = ({ country }: any) => country;

const CitySelect: FC<Props> = props => {
  const { data, regionId, hideCountryName = false, ...rest } = props;
  const [{ value }] = useField<AutocompleteOption>(rest.name);
  let helperText;

  const { cities } = useFragment(
    graphql`
      fragment CitySelect_data on Query {
        cities {
          id
          name

          region {
            id
            name

            country {
              name
            }
          }
        }
      }
    `,
    data
  );

  const options = cities
    .filter(city => !regionId || city.region.id === regionId)
    .map(({ region, ...item }) => {
      if (value && item.id === value.id) {
        helperText = `${region.country.name}, ${region.name}`;
      }

      return {
        ...item,
        country: region.country.name,
      };
    });

  return (
    <Autocomplete
      groupBy={!regionId ? groupBy : undefined}
      options={options}
      helperText={!hideCountryName ? helperText : undefined}
      {...rest}
    />
  );
};

export default CitySelect;
